/**
  Why not just put these in inc-api.utils? Well, I did before, but apparently it
  breaks something with jest mocking in client-alias.test.js since the files
  under test there are imported first by setupTests.js. I don't know how or why
  it works that way, but this fixes it. Whatever
*/

import { compose, context } from 'msw';

export const setSuccessHeaders = () =>
  compose(
    context.set('incentivio-code', 'SUCCESS'),
    context.set('incentivio-message', 'success'),
  );

export const isInvalidToken = req =>
  req.headers.get('authorization')?.includes('invalid');

export const authFailureResponse = (_req, res, ctx) => {
  return res(ctx.status(401));
};
